<template>
	<div class="notes-list__item">
		<div class="flex-grow-1">
			<div class="d-flex align-start justify-space-between">
				<div @click="selectUser" class="d-flex align-start u-cursor-pointer flex-grow-1">
					<Avatar
						borderRadius="square"
						class="notes-list__item-avatar mr-3"
						:size="40"
						:avatar="resourceItem.follow.user_logo"
					/>
					<div class="notes-list__item__username-wrapper">
						<div class="notes-list__item-username text-2-lines pa-0">
							{{ resourceItem.follow.visible_username }}
						</div>
						<div class="notes-list__item-second-row text-2-lines pa-0">
							{{ resourceItem.follow.second_profile_row }}
						</div>
					</div>
				</div>
				<div class="notes-list__item-date pa-0 ma-0">
					{{ dateCreated(resourceItem.note_updated) }}
				</div>
			</div>
			<p
				@click="selectNote"
				v-html="resourceItem.follow_note"
				class="notes-list__item-text"
			/>
		</div>
	</div>
</template>

<script>
import Avatar from '../Avatar'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'NoteItem',
	components: {
		Avatar,
	},
	props: {
		resourceItem: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'isLoading', 'listMeta', 'breadCrumbs']),
	},
	methods: {
		...mapActions('resources', ['breadCrumbHandler']),
		...mapActions('profile', ['updateEditableNote']),
		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000)
			const options = {
				month: 'short',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			}

			return new Intl.DateTimeFormat('en-US', options).format(date)
		},
		selectNote() {
			this.updateEditableNote(this.resourceItem)
			this.$router.push({
				name: 'profile-note-by-id',
				params: { id: this.resourceItem.follow_id },
			})
		},
		selectUser() {
			this.$router.push({ name: 'user-by-id', params: { id: this.resourceItem.follow_id } })
		},
	},
	created() {
		//
	},
}
</script>

<style lang="scss">
.notes-list__item {
	width: 100%;
	display: flex;
	justify-content: space-between;
	flex-wrap: nowrap;
	padding: 12px !important;
	margin-bottom: 8px;
	border-radius: 8px;
	background: #ffffff;
	border: 1px solid #e2e2e2;
	font-family: 'Inter', sans-serif;
	&__username-wrapper {
		flex-grow: 1;
		min-width: 0;
	}
	&-second-row {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 15px;
		line-height: 20px;
		letter-spacing: 0;
		color: var(--company-position-large);
	}

	&-username {
		font-size: 18px;
		font-weight: 700;
		line-height: 21.94px;
		color: var(--username-category-title);
		margin-bottom: 6px;
		.text-2-lines {
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			word-break: break-word;
		}
	}

	&-date {
		width: 98px;
		height: 46px;
		white-space: nowrap;
		display: flex;
		align-items: flex-end;
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: right;
		color: #9b9b9b;
	}

	&-text {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
		margin: 16px 0 0 !important;
		white-space: pre-line;
		word-break: break-word;
		cursor: pointer;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
</style>
